import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";
import { hasAtLeastOneRequiredAction } from "utils/access";
import { SpacesContext } from "views/Account/SpacesProvider";
import { AccountContext } from "views/AccountWrapper";
import { Action, Space } from "types/generated";
import { CREATE_TEMPLATE_ACCESS_TYPES } from "shared/Templates/access/useCanCreateTemplate";

const UPDATE_TEMPLATE_ACCESS_TYPES = [
  Action.SpaceAdmin,
  Action.UpdateBlueprintsVersionedGroup,
];

const useTemplateAvailableSpaces = (isEditing: boolean): Space[] => {
  const { spaces } = useTypedContext(SpacesContext);
  const { viewer } = useTypedContext(AccountContext);

  const accessTypes = isEditing ? UPDATE_TEMPLATE_ACCESS_TYPES : CREATE_TEMPLATE_ACCESS_TYPES;

  const availableSpaces = useMemo(() => {
    return spaces?.filter((space) => {
      return hasAtLeastOneRequiredAction(accessTypes, viewer, space.id);
    });
  }, [spaces, viewer, accessTypes]);

  return availableSpaces || [];
};

export default useTemplateAvailableSpaces;
